import ScamScreen from './ScamScreen.jsx';

export default ScamScreen;